import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';

const BaseAddonCategoryXlsIndex = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS}/${ROUTE_KEYS.BASE_ADDON_CATEGORY_XLS_UPLOAD}`,
      {
        replace: true
      }
    );
  }, []);

  return <div />;
};

export default BaseAddonCategoryXlsIndex;
